import {ApolloClient, ApolloQueryResult, gql} from '@apollo/client';
import {errorResponse, NetworkResult, successResponse} from './NetworkResult';
import {LeaderboardSuggestion} from '../Models/LeaderboardSuggestion';
import {Duration} from '../Domain/Duration';
import {Distance} from '../Domain/Distance';

export class LeaderboardService {
    constructor(private client: ApolloClient<any>) {}

    public async suggestions(): Promise<NetworkResult<LeaderboardSuggestion[]>> {
        try {
            const apolloQueryResult = await this.client.query({
                query: gql`
                    query {
                        me {
                            id
                            leaderboard_suggestions {
                                category
                                category_type
                                time_milliseconds
                                distance_millimeters
                                workout_interval_id
                                executed_at_iso8601
                                season
                            }
                        }
                    }
                `,
            });
            return this.toResponse(apolloQueryResult);
        } catch (e) {
            console.error(e);
            return errorResponse();
        }
    }

    private toResponse(apolloQueryResult: ApolloQueryResult<any>): NetworkResult<LeaderboardSuggestion[]> {
        if (apolloQueryResult.errors) {
            return errorResponse();
        }

        return successResponse(
            apolloQueryResult.data.me.leaderboard_suggestions.map((leaderboardSuggestionResponse: any) => {
                const leaderboardSuggestion: LeaderboardSuggestion = {
                    category: leaderboardSuggestionResponse.category,
                    category_type: leaderboardSuggestionResponse.category_type,
                    duration: Duration.fromMilliseconds(leaderboardSuggestionResponse.time_milliseconds),
                    distance: Distance.fromMillimeters(leaderboardSuggestionResponse.distance_millimeters),
                    workout_interval_id: leaderboardSuggestionResponse.workout_interval_id,
                    executed_at: new Date(leaderboardSuggestionResponse.executed_at_iso8601),
                    season: leaderboardSuggestionResponse.season,
                };

                return leaderboardSuggestion;
            }),
        );
    }
}
